import { API } from '@Providers';

export default async function (payload: string) {
  const endpoint = `/api/shelter/forms/get-outcome-form-by-name/${payload}`;

  return API({ endpoint });
}
